// import ScrollMagic from "scrollmagic";
// import Simplemodal from '../../plugins/simplemodal.js';
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';


// const floating = new Simplemodal({
//   trigger: "data-floating-trigger",
//   backFixed: false
// })


// const controller = new ScrollMagic.Controller();

// const floatingLine = new ScrollMagic.Scene({
//   triggerElement: ".js-floating-showLine",
//   triggerHook: 'onEnter',
//   // duration: 800,
//   offset: 0
// })
//   // .addIndicators()
//   .addTo(controller);

// const header = document.querySelector(".l-header");
// let floatingLinePassing = false;

// //triggerElementを過ぎたとき
// floatingLine.on('enter', () => {

//   // header.classList.add("is-fixed")
//   // header.classList.remove("is-hide")


//   // if (floatingLinePassing) return
//   // floating.open("js-floating")
//   // floatingLinePassing = true;

// });


// floatingLine.on('leave', () => {
//   // header.classList.remove("is-fixed")
//   // header.classList.add("is-hide")
// });


